
export const AccountTypes = [{ title: "Member", id: 1, value: 'member' }, 
{ title: "Not a Member", id: 2, value: 'non-member' },
 { title: "Organization", id: 3, value: 'organization' }]
